// extracted by mini-css-extract-plugin
export default {"buttonContainer":"AddToSectionMenu_buttonContainer__vNbZB"};